import { loadStripe } from '@stripe/stripe-js';
import { PRODUCTS } from '../stripe-config';
import { supabase } from './supabase';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

export async function createCheckoutSession(productId: keyof typeof PRODUCTS, isYearly = false) {
  try {
    const stripe = await stripePromise;
    if (!stripe) {
      throw new Error('Stripe failed to initialize');
    }

    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user?.email) {
      throw new Error('Please sign in to continue');
    }

    const product = PRODUCTS[productId];
    if (!product) {
      throw new Error('Invalid product selection');
    }

    const priceId = isYearly ? product.yearlyPriceId : product.priceId;
    if (!priceId) {
      throw new Error('Product price configuration error');
    }

    const { data, error } = await supabase.functions.invoke('create-checkout-session', {
      body: {
        priceId,
        userEmail: session.user.email,
        productId: product.id,
        isFromCourse: productId === 'AI_TUTOR_HUB',
        successUrl: `${window.location.origin}/thank-you?session_id={CHECKOUT_SESSION_ID}`,
        cancelUrl: `${window.location.origin}/checkout-cancel`
      }
    });

    if (error) {
      console.error('Checkout session creation error:', error);
      throw new Error(error.message || 'Failed to create checkout session');
    }

    if (!data?.url) {
      throw new Error('No checkout URL returned from server');
    }

    // Redirect to Stripe Checkout
    window.location.href = data.url;
  } catch (error: any) {
    console.error('Checkout error:', error);
    throw error;
  }
}

export function getProductFromUrl(): keyof typeof PRODUCTS {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  
  return ref === 'course' || ref === 'community' 
    ? 'AI_TUTOR_HUB' 
    : 'AI_LEARNING_HUB';
}